/**
 * Who owns the browser tab title.
 *
 * CAMP-2026-0680 — `dist/index.html` is both the prerendered marketing home
 * page and the host's SPA fallback, so an app route arrives carrying the
 * marketing <head>: the admin dashboard's tab read "India Education Operating
 * System". scripts/prerender.mjs corrects that before first paint on a hard
 * load, but a CLIENT-side navigation (home → /login) hits the same thing from
 * the other direction — `useSeo`'s cleanup restores whatever title was there
 * when the marketing page mounted, which is the marketing title.
 *
 * So the app asserts its own title on every navigation, and the marketing
 * pages — which legitimately need their own SEO titles — say so by claiming
 * ownership while they are mounted. Effects flush children-first, so a page
 * that claims the title always wins over the router-level assertion above it.
 */

export const APP_DOCUMENT_TITLE = "CampusHubAI";

let owners = 0;

/** Called by `useSeo` — the page sets its own title until the returned undo runs. */
export function claimDocumentTitle(): () => void {
  owners += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    owners -= 1;
  };
}

/** Router-level default: restore the app title unless a page owns it. */
export function assertAppDocumentTitle(): void {
  if (owners === 0 && document.title !== APP_DOCUMENT_TITLE) {
    document.title = APP_DOCUMENT_TITLE;
  }
}
